import { fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { SAVE_FAVOURITE_LOCATION } from 'app/constants';
import saveLocation from './saveLocation';

export default function* watchSaveLocation() {
  yield fork(takeLatest, SAVE_FAVOURITE_LOCATION, saveLocation);
}
